import { Component, OnInit } from '@angular/core';
import { DataTransferServiceService } from '../services/data-transfer-service.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(
    private dataTransferService: DataTransferServiceService,

  ) { }

  ngOnInit(): void {
    const currentUrl = window.location.href; 
    this.dataTransferService.logPageVisitByIp(currentUrl);
  }

}
